import React, { PropTypes } from 'react';
import TcDayPicker from './date-picker';
import Icon from './icon';
import { TextField } from 'material-ui';

const DatePickerSet = ({
  disabledRanges,
  style,
  showTextField,
  textFieldStyle,
  textFieldOnChange,
  textFieldValue,
  textFieldFloatingText,
  startDateContainerStyle,
  startDateTextFieldStyle,
  onChangeStartDate,
  initialStartDateMonth,
  startDateFloatingText,
  startDateHintText,
  startDate,
  startDateErrorText,
  startDateCloseOnSelect,
  startDateEnableFrom,
  startDateEnableTo,
  disableDeleteButton,
  addButtonStyle,
  deleteButtonStyle,
  onDelete,
  onAdd,
  endDateContainerStyle,
  endDateTextFieldStyle,
  onChangeEndDate,
  initialEndDateMonth,
  endDateFloatingText,
  endDateHintText,
  endDate,
  endDateErrorText,
  endDateCloseOnSelect,
  endDateEnableFrom,
  endDateEnableTo,
  renderDay,
  startDateDisabled,
  endDateDisabled,
  startDateUnderlineStyle,
  endDateUnderlineStyle,
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'baseline' }}>
      {
        showTextField ?
        <TextField
          style={{ height: '48px', ...textFieldStyle }}
          hintStyle={{ top: '15px' }}
          floatingLabelStyle={{ top: '15px' }}
          inputStyle={{ top: '-12px' }}
          onChange={textFieldOnChange}
          value={textFieldValue || ''}
          floatingLabelText={textFieldFloatingText}
        /> : undefined
      }
      <TcDayPicker
        disabled={startDateDisabled}
        containerStyle={startDateContainerStyle}
        textFieldStyle={startDateTextFieldStyle}
        onChange={onChangeStartDate}
        floatingLabelText={startDateFloatingText}
        hintText={startDateHintText}
        initialMonth={initialStartDateMonth}
        value={startDate}
        errorText={startDateErrorText}
        closeOnSelect={startDateCloseOnSelect}
        enableFrom={startDateEnableFrom}
        enableTo={startDateEnableTo}
        disabledRanges={disabledRanges}
        renderDay={renderDay}
        underlineStyle={startDateUnderlineStyle}
      />
      <TcDayPicker
        disabled={endDateDisabled}
        containerStyle={endDateContainerStyle}
        textFieldStyle={endDateTextFieldStyle}
        onChange={onChangeEndDate}
        floatingLabelText={endDateFloatingText}
        hintText={endDateHintText}
        initialMonth={initialEndDateMonth}
        value={endDate}
        errorText={endDateErrorText}
        closeOnSelect={endDateCloseOnSelect}
        enableFrom={endDateEnableFrom}
        enableTo={endDateEnableTo}
        disabledRanges={disabledRanges}
        renderDay={renderDay}
        underlineStyle={endDateUnderlineStyle}
      />
      <Icon
        className="tc-icon-close"
        style={{
          color: disableDeleteButton ? 'grey' : '#ff4081',
          cursor: disableDeleteButton ? 'normal' : 'pointer',
          ...deleteButtonStyle,
        }}
        onClick={disableDeleteButton ? undefined : onDelete}
      />
      <Icon
        className="tc-icon-add"
        style={{
          border: '2px solid green',
          borderRadius: '50%',
          cursor: 'pointer',
          ...addButtonStyle,
        }}
        onClick={onAdd}
      />
    </div>
  );
};

DatePickerSet.propTypes = {
  style: PropTypes.object,
  showTextField: PropTypes.bool,
  textFieldStyle: PropTypes.object,
  textFieldOnChange: PropTypes.func,
  textFieldValue: PropTypes.any,
  textFieldFloatingText: PropTypes.string,
  startDateContainerStyle: PropTypes.object,
  startDateTextFieldStyle: PropTypes.object,
  onChangeStartDate: PropTypes.func,
  initialStartDateMonth: PropTypes.any,
  startDateFloatingText: PropTypes.string,
  startDate: PropTypes.any,
  startDateErrorText: PropTypes.string,
  startDateCloseOnSelect: PropTypes.bool,
  disableDeleteButton: PropTypes.bool,
  addButtonStyle: PropTypes.object,
  deleteButtonStyle: PropTypes.object,
  onDelete: PropTypes.func,
  onAdd: PropTypes.func,
  endDateContainerStyle: PropTypes.object,
  endDateTextFieldStyle: PropTypes.object,
  onChangeEndDate: PropTypes.func,
  initialEndDateMonth: PropTypes.any,
  endDateFloatingText: PropTypes.string,
  endDate: PropTypes.any,
  endDateErrorText: PropTypes.string,
  endDateCloseOnSelect: PropTypes.bool,
};

export default DatePickerSet;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/date-picker-set.jsx